import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.users');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-admin-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.users/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #ffffff;
  color: #333333;
  font-family: SUIT, Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
}

.users-page {
  width: min(1360px, 100% - 48px);
  min-height: 100vh;
  margin: 0 auto;
  padding: 20px 0 36px;
  background: #ffffff;
  color: #333333;
}

.users-header,
.pending-priority,
.access-summary,
.summary-card,
.filter-panel,
.table-panel,
.detail-panel {
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
}

.users-header,
.pending-priority,
.access-summary,
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.users-header {
  padding: 18px 20px;
}

.users-title {
  min-width: 0;
}

.users-title p,
.users-title h1,
.users-title span,
.pending-priority p,
.pending-priority strong,
.pending-priority span,
.access-summary p,
.access-summary span {
  margin: 0;
}

.users-title p,
.pending-priority p {
  color: #666666;
  font-size: 13px;
  font-weight: 600;
}

.users-title h1 {
  margin-top: 4px;
  color: #222222;
  font-size: 23px;
  font-weight: 700;
  line-height: 1.3;
}

.users-title span,
.pending-priority span,
.access-summary p {
  display: block;
  margin-top: 5px;
  color: #666666;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
}

.users-header nav,
.filter-actions,
.action-cell,
.inline-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.pending-priority {
  margin-top: 12px;
  padding: 16px;
  border-color: #2b2b2b;
}

.pending-priority strong {
  display: block;
  margin-top: 2px;
  color: #222222;
  font-size: 20px;
  font-weight: 700;
}

.access-summary {
  margin: 12px 0;
  padding: 12px 16px;
  background: #f5f5f5;
}

.access-summary div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.access-summary span {
  color: #666666;
  font-size: 14px;
}

.access-summary strong {
  color: #222222;
  font-size: 15px;
  font-weight: 700;
}

.users-header a,
.button-secondary,
.button-primary,
.button-danger,
.action-button {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #bdbdbd;
  border-radius: 8px;
  padding: 0 12px;
  background: #ffffff;
  color: #2b2b2b;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
}

.button-primary,
.action-button.primary {
  border-color: #2b2b2b;
  background: #2b2b2b;
  color: #ffffff;
}

.button-danger,
.action-button.danger {
  border-color: #9a2a2a;
  background: #9a2a2a;
  color: #ffffff;
}

.users-header a:hover,
.button-secondary:hover,
.action-button:not(.primary):not(.danger):hover {
  border-color: #2b2b2b;
  background: #f5f5f5;
}

.users-header a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
summary:focus-visible {
  outline: 3px solid rgba(43, 43, 43, 0.22);
  outline-offset: 2px;
}

button:disabled,
input:disabled,
select:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.action-button {
  min-height: 32px;
  padding: 0 9px;
  font-size: 13px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin: 12px 0;
}

.summary-card {
  min-width: 0;
  position: relative;
  padding: 14px;
  text-align: left;
  cursor: pointer;
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  border-radius: 8px 0 0 8px;
  background: #777777;
}

.summary-card.is-pending::before,
.summary-card.is-inactive::before {
  background: #9a2a2a;
}

.summary-card.is-admin::before {
  background: #2b2b2b;
}

.summary-card.is-active {
  border-color: #2b2b2b;
  background: #f5f5f5;
}

.summary-card span,
.summary-card em {
  display: block;
  color: #666666;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.summary-card strong {
  display: block;
  margin-top: 6px;
  color: #222222;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
}

.filter-panel {
  margin-bottom: 12px;
  padding: 14px;
}

.filter-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
}

.filter-title strong,
.table-toolbar strong,
.permission-editor strong,
.password-panel strong,
.capability-panel > strong {
  color: #222222;
  font-size: 15px;
  font-weight: 700;
}

.filter-title span,
.table-toolbar span,
.table-toolbar p {
  margin: 0;
  color: #666666;
  font-size: 14px;
  font-weight: 400;
}

.filter-grid {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) repeat(3, minmax(150px, 180px)) auto;
  gap: 8px;
  align-items: end;
}

.filter-grid label,
.role-editor,
.password-panel label {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.filter-grid label > span,
.role-editor > span,
.password-panel label > span {
  color: #555555;
  font-size: 14px;
  font-weight: 600;
}

.filter-grid input,
.filter-grid select,
.role-editor select,
.password-panel input {
  width: 100%;
  min-width: 0;
  min-height: 38px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 0 10px;
  background: #ffffff;
  color: #333333;
  font-size: 15px;
  font-weight: 400;
}

.notice {
  margin: 0 0 12px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  font-weight: 600;
}

.notice.success {
  background: #eef7f1;
  color: #17633d;
}

.notice.error {
  background: #fff0f0;
  color: #8b2424;
}

.management-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
}

.management-layout.has-detail {
  grid-template-columns: minmax(0, 1fr) 420px;
  align-items: start;
}

.table-panel {
  min-width: 0;
  overflow: hidden;
}

.table-toolbar {
  padding: 12px 16px;
  border-bottom: 1px solid #d8d8d8;
  background: #f5f5f5;
}

.table-toolbar > div {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
}

.users-table {
  width: 100%;
  min-width: 1260px;
  border-collapse: collapse;
  table-layout: fixed;
}

.users-table th,
.users-table td {
  border-bottom: 1px solid #e2e2e2;
  padding: 12px 10px;
  vertical-align: top;
  text-align: left;
  word-break: normal;
  overflow-wrap: break-word;
}

.users-table th {
  background: #f5f5f5;
  color: #555555;
  font-size: 14px;
  font-weight: 600;
}

.users-table td {
  color: #333333;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.45;
}

.users-table tr.is-admin-row td {
  background: #fafafa;
}

.users-table tr.is-selected td {
  background: #f5f5f5;
}

.col-account {
  width: 190px;
}

.col-role {
  width: 230px;
}

.col-approval {
  width: 125px;
}

.col-active {
  width: 120px;
}

.col-permission {
  width: 235px;
}

.col-required {
  width: 175px;
}

.col-actions {
  width: 185px;
}

.account-cell {
  min-width: 0;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
}

.account-cell > div,
.authority-cell,
.state-cell,
.permission-cell,
.required-cell {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.account-avatar {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  background: #f5f5f5;
  color: #555555;
  font-size: 14px;
  font-weight: 700;
}

.account-avatar.is-admin {
  border-color: #2b2b2b;
  background: #2b2b2b;
  color: #ffffff;
}

.account-cell strong,
.permission-cell strong,
.required-cell strong {
  overflow: hidden;
  color: #222222;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-cell span,
.account-cell em,
.account-cell small,
.authority-cell > span:not(.role-badge),
.state-cell > span:not(.status-badge),
.permission-cell span,
.required-cell span {
  overflow: hidden;
  color: #666666;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-cell small {
  width: fit-content;
  border-radius: 999px;
  padding: 2px 7px;
  background: #ededed;
  color: #444444;
  font-weight: 600;
}

.mono-cell {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.status-badge,
.role-badge {
  width: fit-content;
  max-width: 100%;
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cfcfcf;
  border-radius: 999px;
  padding: 2px 9px;
  background: #f5f5f5;
  color: #444444;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.25;
  white-space: normal;
}

.status-badge.is-approved,
.status-badge.is-active {
  border-color: #87ac96;
  background: #eef7f1;
  color: #17633d;
}

.status-badge.is-pending {
  border-color: #c3a36a;
  background: #fff8e8;
  color: #795100;
}

.status-badge.is-rejected,
.status-badge.is-inactive {
  border-color: #d7a3a3;
  background: #fff0f0;
  color: #8b2424;
}

.role-badge.is-admin {
  border-color: #8b8b8b;
  background: #ededed;
  color: #222222;
}

.permission-cell strong.is-empty {
  color: #777777;
}

.action-cell {
  align-items: flex-start;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid #d8d8d8;
  padding: 12px;
}

.pagination span {
  color: #555555;
  font-size: 14px;
}

.empty-state {
  margin: 0;
  padding: 24px;
  color: #666666;
  font-size: 15px;
}

.detail-panel {
  position: sticky;
  top: 14px;
  padding: 16px;
}

.detail-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
}

.detail-panel header p,
.detail-panel header h2 {
  margin: 0;
}

.detail-panel header p {
  color: #666666;
  font-size: 13px;
}

.detail-panel header h2 {
  margin-top: 3px;
  color: #222222;
  font-size: 19px;
  font-weight: 700;
}

.detail-panel header span {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.detail-body {
  display: grid;
  gap: 12px;
}

.capability-panel,
.edit-panel,
.password-panel,
.technical-details {
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 12px;
}

.capability-panel {
  background: #f5f5f5;
}

.capability-panel ul {
  margin: 8px 0;
  padding-left: 20px;
}

.capability-panel li,
.capability-panel p {
  margin: 3px 0;
  color: #444444;
  font-size: 14px;
}

.edit-panel,
.password-panel {
  display: grid;
  gap: 12px;
  background: #ffffff;
}

.warning-box {
  display: grid;
  gap: 4px;
  border: 1px solid #d7a3a3;
  border-radius: 8px;
  padding: 10px;
  background: #fff0f0;
}

.warning-box strong {
  color: #8b2424;
  font-size: 14px;
  font-weight: 700;
}

.warning-box span,
.permission-editor span,
.permission-editor small,
.password-panel span,
.role-editor small,
.separated-state-grid small,
.separated-state-grid span {
  color: #666666;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;
}

.separated-state-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.separated-state-grid > section {
  min-width: 0;
  display: grid;
  gap: 7px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 10px;
  background: #f5f5f5;
}

.separated-state-grid strong {
  color: #222222;
  font-size: 14px;
  font-weight: 700;
}

.permission-editor {
  display: grid;
  gap: 8px;
  border-top: 1px solid #d8d8d8;
  padding-top: 12px;
}

.permission-editor > div,
.password-panel > div {
  display: grid;
  gap: 3px;
}

.permission-check {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #444444;
  font-size: 14px;
}

.permission-check input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #2b2b2b;
}

.permission-save,
.password-panel button {
  justify-self: start;
}

.detail-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
  border-radius: 8px;
  padding: 12px;
  background: #f5f5f5;
}

.detail-list div {
  min-width: 0;
  border-top: 1px solid #d8d8d8;
  padding-top: 8px;
}

.detail-list dt,
.technical-details dt {
  color: #666666;
  font-size: 13px;
  font-weight: 600;
}

.detail-list dd,
.technical-details dd {
  margin: 4px 0 0;
  color: #333333;
  font-size: 14px;
  word-break: break-word;
}

.detail-wide {
  grid-column: 1/-1;
}

.technical-details summary {
  cursor: pointer;
  color: #333333;
  font-size: 14px;
  font-weight: 600;
}

.technical-details dl {
  display: grid;
  gap: 8px;
  margin: 12px 0 0;
}

.technical-details dl div {
  border-top: 1px solid #e2e2e2;
  padding-top: 7px;
}

.detail-loading {
  margin: 0;
  color: #666666;
  font-size: 15px;
}

@media (max-width: 1180px) {
  .management-layout.has-detail {
    grid-template-columns: 1fr;
  }
  .detail-panel {
    position: static;
  }
}
@media (max-width: 1050px) {
  .filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .search-field {
    grid-column: 1/-1;
  }
}
@media (max-width: 760px) {
  .users-page {
    width: min(1360px, 100% - 28px);
    padding-top: 14px;
  }
  .users-header,
  .pending-priority,
  .access-summary,
  .filter-title,
  .table-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .summary-grid,
  .filter-grid,
  .separated-state-grid,
  .detail-list {
    grid-template-columns: 1fr;
  }
  .detail-wide,
  .search-field {
    grid-column: auto;
  }
  .filter-actions,
  .users-header nav {
    width: 100%;
  }
  .filter-actions button {
    flex: 1 1 auto;
  }
  .pending-priority .button-primary {
    width: 100%;
  }
}`],
})
export class PageAdminUsersComponent implements OnInit {
    public users: any[] = [];
    public approvalStatusLabels: any = {};
    public activeStatusLabels: any = {};
    public roleLabels: any = {};
    public providerLabels: any = {};
    public materialPermissionLabels: any = {};
    public approvalOptions: Array<{ value: string, label: string }> = [];
    public activeOptions: Array<{ value: string, label: string }> = [];
    public roleOptions: Array<{ value: string, label: string }> = [];
    public materialPermissionOptions: Array<{ value: string, label: string }> = [];
    public summaryCounts: any = {};
    public dashboardCards: any[] = [];
    public filters: any = { text: '', approval: '', active: '', role: '', page: 1, dump: 10 };
    public pagination: any = { page: 1, dump: 10, total: 0, pageCount: 1, from: 0, to: 0 };
    public selectedUser: any = null;
    public permissionDraft: string[] = [];
    public loading: boolean = false;
    public detailLoading: boolean = false;
    public resetPasswordValue: string = '';
    public resetPasswordConfirm: string = '';
    public message: string = '';
    public errorMessage: string = '';
    public busyUsers: any = {};
    public resetBusy: boolean = false;
    private listRequestSequence: number = 0;
    private detailRequestSequence: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadUsers();
    }

    public responseMessage(response: any, fallback: string = '요청을 처리하지 못했습니다.'): string {
        let data = response?.data;
        if (typeof data === 'string') return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public displayTerm(value: any): string {
        let text = value === null || value === undefined ? '' : `${value}`;
        return text
            .replace(/검수/g, '자료 확인')
            .replace(/내부열람/g, '내부 사용자만 열람')
            .replace(/내부자료/g, '내부 자료');
    }

    public optionsFromLabels(labels: any): Array<{ value: string, label: string }> {
        return Object.keys(labels || {}).map((value) => ({ value, label: labels[value] }));
    }

    public buildDashboardCards() {
        let summary = this.summaryCounts || {};
        this.dashboardCards = [
            {
                key: 'pending',
                label: '승인대기',
                value: summary.pending || 0,
                description: '가입 검토가 필요한 계정',
                approval: 'pending',
                active: '',
                role: '',
            },
            {
                key: 'total',
                label: '전체 회원',
                value: summary.total || 0,
                description: '등록된 전체 계정',
                approval: '',
                active: '',
                role: '',
            },
            {
                key: 'admin',
                label: '관리자',
                value: summary.admin || 0,
                description: '회원·권한 관리 역할',
                approval: '',
                active: '',
                role: 'admin',
            },
            {
                key: 'inactive',
                label: '비활성 계정',
                value: summary.inactive || 0,
                description: '가입 승인과 별도인 이용 중지',
                approval: '',
                active: 'inactive',
                role: '',
            },
        ];
    }

    public async loadUsers(preserveMessages: boolean = false) {
        let sequence = ++this.listRequestSequence;
        this.loading = true;
        if (!preserveMessages) {
            this.message = '';
            this.errorMessage = '';
        }
        await this.service.render();

        let response = await wiz.call('users', this.filters);
        if (sequence !== this.listRequestSequence) return;
        this.loading = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, '사용자 목록을 불러오지 못했습니다.');
            await this.service.render();
            return;
        }

        this.users = response.data?.users || [];
        this.pagination = response.data?.pagination || this.pagination;
        this.filters.page = this.pagination.page || 1;
        this.approvalStatusLabels = response.data?.approvalStatusLabels || {};
        this.activeStatusLabels = response.data?.activeStatusLabels || {};
        this.roleLabels = response.data?.roleLabels || {};
        this.providerLabels = response.data?.providerLabels || {};
        this.materialPermissionLabels = response.data?.materialPermissionLabels || {};
        this.summaryCounts = response.data?.summary || {};
        this.approvalOptions = this.optionsFromLabels(this.approvalStatusLabels);
        this.activeOptions = this.optionsFromLabels(this.activeStatusLabels);
        this.roleOptions = this.optionsFromLabels(this.roleLabels);
        this.materialPermissionOptions = this.optionsFromLabels(this.materialPermissionLabels);
        this.buildDashboardCards();

        if (this.selectedUser) {
            let refreshed = this.users.find((user) => user.id === this.selectedUser.id);
            if (refreshed) {
                this.selectedUser = refreshed;
                this.syncPermissionDraft(refreshed);
            } else {
                this.closeDetail();
            }
        }
        await this.service.render();
    }

    public async applyFilters() {
        this.filters.page = 1;
        this.closeDetail();
        await this.loadUsers();
    }

    public async openDetail(user: any) {
        let sequence = ++this.detailRequestSequence;
        this.selectedUser = user;
        this.detailLoading = true;
        this.resetPasswordValue = '';
        this.resetPasswordConfirm = '';
        this.message = '';
        this.errorMessage = '';
        this.syncPermissionDraft(user);
        await this.service.render();

        let response = await wiz.call('user_detail', { id: user.id });
        if (sequence !== this.detailRequestSequence || this.selectedUser?.id !== user.id) return;
        this.detailLoading = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, '사용자 상세 정보를 불러오지 못했습니다.');
            await this.service.render();
            return;
        }
        this.selectedUser = response.data?.user || user;
        this.syncPermissionDraft(this.selectedUser);
        await this.service.render();
    }

    public closeDetail() {
        this.detailRequestSequence += 1;
        this.selectedUser = null;
        this.permissionDraft = [];
        this.detailLoading = false;
        this.resetPasswordValue = '';
        this.resetPasswordConfirm = '';
    }

    public currentUserId(): string {
        return this.service.auth.session?.id || '';
    }

    public currentUserName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || '관리자';
    }

    public isSelf(user: any): boolean {
        return !!user && user.id === this.currentUserId();
    }

    public isBusy(user: any): boolean {
        return !!user && !!this.busyUsers[user.id];
    }

    public canMutate(user: any): boolean {
        return !!user && !this.isSelf(user) && !user.protectedAdmin && !this.isBusy(user);
    }

    public async performMutation(user: any, action: string, value: any = null) {
        if (!user || this.isBusy(user)) return;
        this.busyUsers[user.id] = action;
        this.message = '';
        this.errorMessage = '';
        await this.service.render();

        let response: any;
        try {
            response = await wiz.call('update_user', {
                id: user.id,
                action,
                value,
                expected_version: user.versionToken,
            });
        } catch (error) {
            delete this.busyUsers[user.id];
            this.errorMessage = '서버 저장에 실패했습니다. 현재 목록과 승인대기 수는 변경하지 않았습니다.';
            await this.service.render();
            return;
        }

        delete this.busyUsers[user.id];
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, '사용자 정보를 변경하지 못했습니다.');
            if (response.code === 409) {
                await this.loadUsers(true);
            } else {
                await this.service.render();
            }
            return;
        }

        let saved = response.data?.user;
        if (saved) {
            this.users = this.users.map((item) => item.id === saved.id ? saved : item);
            if (this.selectedUser?.id === saved.id) {
                this.selectedUser = saved;
                this.syncPermissionDraft(saved);
            }
        }
        let successMessage = response.data?.message || '서버 저장을 확인했습니다.';
        await this.loadUsers(true);
        this.message = successMessage;
        await this.service.render();
    }

    public async setApproval(user: any, approval: string) {
        if (!this.canMutate(user) || this.approvalStatus(user) === approval) return;
        if (approval === 'rejected') {
            let confirmed = await this.confirmDangerAction({
                title: '가입 신청 반려 확인',
                message: `현재 가입 승인: ${this.approvalLabel(user)} / 변경 후: ${this.label(this.approvalStatusLabels, 'rejected')}. 역할(${this.roleLabel(user)})과 자료 관리 권한은 변경하지 않습니다.`,
                action: '반려',
                status: 'error',
            });
            if (!confirmed) return;
        }
        await this.performMutation(user, approval === 'approved' ? 'approve' : 'reject');
    }

    public async setActive(user: any, activeStatus: string) {
        if (!this.canMutate(user) || this.activeStatus(user) === activeStatus) return;
        let confirmed = await this.confirmDangerAction({
            title: activeStatus === 'inactive' ? '계정 비활성화 확인' : '계정 활성화 확인',
            message: `현재 활성 상태: ${this.activeLabel(user)} / 변경 후: ${this.label(this.activeStatusLabels, activeStatus)}. 가입 승인(${this.approvalLabel(user)})과 역할(${this.roleLabel(user)})은 변경하지 않습니다.`,
            action: activeStatus === 'inactive' ? '비활성화' : '활성화',
            status: activeStatus === 'inactive' ? 'error' : 'warning',
        });
        if (!confirmed) return;
        await this.performMutation(user, activeStatus === 'active' ? 'activate' : 'deactivate');
    }

    public async setRole(user: any, role: string) {
        if (!this.canMutate(user) || user.role === role) return;
        let isAdminChange = role === 'admin' || user.role === 'admin';
        let confirmed = await this.confirmDangerAction({
            title: isAdminChange ? '관리자 역할 변경 확인' : '역할 변경 확인',
            message: `현재 역할: ${this.roleLabel(user)} / 변경 후: ${this.label(this.roleLabels, role)}. 가입 승인과 활성 상태는 변경하지 않습니다.`,
            action: '역할 변경',
            status: isAdminChange ? 'warning' : 'warning',
        });
        if (!confirmed) return;
        await this.performMutation(user, 'change_role', role);
    }

    public approvalStatus(user: any): string {
        return user?.approvalStatus || user?.approval_status || (user?.status === 'rejected' ? 'rejected' : user?.status === 'pending' ? 'pending' : 'approved');
    }

    public activeStatus(user: any): string {
        if (user?.activeStatus) return user.activeStatus;
        if (user?.isActive === false || user?.is_active === false || user?.status === 'inactive') return 'inactive';
        return 'active';
    }

    public approvalLabel(user: any): string {
        return user?.approvalStatusLabel || this.label(this.approvalStatusLabels, this.approvalStatus(user));
    }

    public activeLabel(user: any): string {
        return user?.activeStatusLabel || this.label(this.activeStatusLabels, this.activeStatus(user));
    }

    public roleLabel(user: any): string {
        return user?.roleLabel || this.label(this.roleLabels, user?.role);
    }

    public roleSummary(user: any): string {
        return `역할: ${this.roleLabel(user)}`;
    }

    public materialPermissions(user: any): string[] {
        let value = user?.materialsPermissions || [];
        if (Array.isArray(value)) return value;
        return [];
    }

    public materialPermissionGrants(user: any): string[] {
        let value = user?.materialPermissionGrants || [];
        if (Array.isArray(value)) return value;
        return [];
    }

    public hasMaterialPermissions(user: any): boolean {
        return this.materialPermissions(user).length > 0;
    }

    public hasMaterialPermission(user: any, permission: string): boolean {
        return this.materialPermissions(user).includes(permission);
    }

    public isMaterialPermissionLocked(user: any): boolean {
        return user?.role === 'admin' || !this.canMutate(user);
    }

    public materialPermissionNames(permissions: string[]): string {
        if (!permissions || permissions.length === 0) return '없음';
        return permissions.map((permission) => this.label(this.materialPermissionLabels, permission)).join(', ');
    }

    public materialPermissionSummary(user: any): string {
        return `자료 관리 권한: ${this.materialPermissionNames(this.materialPermissions(user))}`;
    }

    public generalUseSummary(user: any): string {
        return user?.capabilities?.generalAccessLabel || '일반 이용 가능 여부 확인 필요';
    }

    public accountManagementSummary(user: any): string {
        return user?.capabilities?.accountManagement ? '회원·권한 관리 가능' : '회원·권한 관리 불가';
    }

    public requiredActionLabel(user: any): string {
        return user?.requiredAction?.label || '필요한 작업 없음';
    }

    public syncPermissionDraft(user: any) {
        if (!user) {
            this.permissionDraft = [];
            return;
        }
        this.permissionDraft = [...this.materialPermissions(user)];
    }

    public permissionDraftHas(permission: string): boolean {
        return this.permissionDraft.includes(permission);
    }

    public togglePermissionDraft(permission: string, event: any) {
        if (!this.selectedUser || this.isMaterialPermissionLocked(this.selectedUser)) return;
        let checked = !!event?.target?.checked;
        let all = this.materialPermissionOptions.map((option) => option.value);
        if (permission === 'materials_admin') {
            this.permissionDraft = checked ? all : [];
        } else if (checked) {
            if (!this.permissionDraft.includes(permission)) this.permissionDraft.push(permission);
        } else {
            this.permissionDraft = this.permissionDraft.filter((item) => item !== permission && item !== 'materials_admin');
        }
    }

    public permissionDraftChanged(): boolean {
        let current = [...this.materialPermissions(this.selectedUser)].sort();
        let next = [...this.permissionDraft].sort();
        return JSON.stringify(current) !== JSON.stringify(next);
    }

    public async saveMaterialPermissions() {
        let user = this.selectedUser;
        if (!user || !this.canMutate(user) || user.role === 'admin' || !this.permissionDraftChanged()) return;
        let confirmed = await this.confirmDangerAction({
            title: '자료 관리 권한 변경 확인',
            message: `현재: ${this.materialPermissionNames(this.materialPermissions(user))} / 변경 후: ${this.materialPermissionNames(this.permissionDraft)}. 역할과 가입 승인·활성 상태는 변경하지 않습니다.`,
            action: '권한 저장',
            status: 'warning',
        });
        if (!confirmed) return;
        await this.performMutation(user, 'change_material_permissions', JSON.stringify(this.permissionDraft));
    }

    public async filterDashboard(card: any) {
        this.filters = {
            ...this.filters,
            text: '',
            approval: card.approval || '',
            active: card.active || '',
            role: card.role || '',
            page: 1,
        };
        this.closeDetail();
        await this.loadUsers();
    }

    public isDashboardActive(card: any): boolean {
        return (
            (this.filters.text || '') === ''
            && (this.filters.role || '') === (card.role || '')
            && (this.filters.approval || '') === (card.approval || '')
            && (this.filters.active || '') === (card.active || '')
        );
    }

    public async clearFilters() {
        this.filters = { text: '', approval: '', active: '', role: '', page: 1, dump: 10 };
        this.closeDetail();
        await this.loadUsers();
    }

    public async movePage(page: number) {
        if (this.loading || page < 1 || page > (this.pagination.pageCount || 1) || page === this.pagination.page) return;
        this.filters.page = page;
        this.closeDetail();
        await this.loadUsers();
    }

    public async resetPassword(user: any) {
        user = user || this.selectedUser;
        if (!user || this.resetBusy) return;
        let password = this.resetPasswordValue || '';
        let passwordConfirm = this.resetPasswordConfirm || '';
        this.message = '';
        this.errorMessage = '';
        if (password.length < 8) {
            this.errorMessage = '새 비밀번호는 8자 이상으로 입력해주세요.';
            await this.service.render();
            return;
        }
        if (password !== passwordConfirm) {
            this.errorMessage = '새 비밀번호 확인이 일치하지 않습니다.';
            await this.service.render();
            return;
        }

        let confirmed = await this.confirmDangerAction({
            title: '비밀번호 재설정 확인',
            message: `${user.username} 계정의 비밀번호를 새 값으로 교체합니다. 새 비밀번호는 저장 후 화면에 다시 표시되지 않습니다.`,
            action: '재설정',
            status: 'warning',
        });
        if (!confirmed) return;

        this.resetBusy = true;
        await this.service.render();
        let response = await wiz.call('reset_password', { id: user.id, password });
        this.resetBusy = false;
        if (response.code !== 200) {
            this.errorMessage = this.responseMessage(response, '비밀번호를 변경하지 못했습니다.');
            await this.service.render();
            return;
        }
        this.resetPasswordValue = '';
        this.resetPasswordConfirm = '';
        this.message = '비밀번호가 변경되었습니다.';
        await this.loadUsers(true);
    }

    public async confirmDangerAction(opts: any): Promise<boolean> {
        if (this.service?.modal?.show) {
            let result = await this.service.modal.show({
                title: opts.title,
                message: opts.message,
                action: opts.action || '확인',
                cancel: '취소',
                status: opts.status || 'warning',
                actionBtn: opts.status || 'warning',
            });
            return !!result;
        }
        return window.confirm(opts.message);
    }

    public label(map: any, value: string): string {
        return map?.[value] || value || '-';
    }

    public fallback(value: any, empty: string = '-'): string {
        return value ? String(value) : empty;
    }

    public providerLabel(user: any): string {
        return user?.providerLabel || this.label(this.providerLabels, user?.provider);
    }

    public statusClass(status: string): string {
        return `is-${status || 'unknown'}`;
    }

    public roleClass(role: string): string {
        return `is-${role || 'user'}`;
    }

    public isAdminRole(user: any): boolean {
        return user?.role === 'admin';
    }

    public accountInitial(user: any): string {
        let source = this.fallback(user?.name || user?.username, '');
        return source ? source.slice(0, 1).toUpperCase() : '?';
    }

    public dateText(value: any, empty: string = '-'): string {
        let text = this.fallback(value, empty);
        if (text === empty) return empty;
        return text.split(' ')[0] || text;
    }

    public timeText(value: any): string {
        let text = this.fallback(value, '');
        if (!text) return '';
        let parts = text.split(' ');
        return parts.length > 1 ? parts[1].slice(0, 5) : '';
    }

    public trackUser(index: number, user: any) {
        return user?.id || index;
    }
}

export default PageAdminUsersComponent;